import React from 'react'
import { Global } from '@emotion/core'
import { ThemeProvider, Flex, Box, css } from 'theme-ui'
import theme from '@elegantstack/flow-ui-theme/src/theme'
import pageContextProvider from '@helpers/pageContextProvider'
import { Header } from '@elegantstack/flow-ui-layout/src/Header/Header'
import { Footer } from '@elegantstack/flow-ui-layout/src/Footer/Footer'
import CookieConsent, { Cookies } from 'react-cookie-consent';

export const Layout = ({ children, pageContext, location }) => (
  <ThemeProvider theme={theme}>
    <pageContextProvider.Provider value={{ pageContext, location }}>
      <CookieConsent

        location="bottom"
        buttonText="Accept"
        onAccept={() => {Cookies.set("gatsby-gdpr-google-analytics", "true"); Cookies.set("gatsby-gdpr-facebook-pixel", "true"); }}
        declineButtonText="Decline"
        cookieName="gatsby-gdpr-google-analytics">
        This website stores cookies on your computer. These cookies are used to collect information about how you interact with this website and allow us to remember you.<br/>
        We use this information in order to improve and customize your browsing experience and for analytics and metrics about our visitors on this website.<br/>
        <br/>
        If you decline, your information won’t be tracked when you visit this website. A single cookie will be used in your browser to remember your preference not to be tracked.
      </CookieConsent>

      <Flex variant='layout.layout'>
        <Global styles={css(theme => theme.global)} />
        <Header />
        <Box variant='layout.body'>{children}</Box>
        <Footer />
      </Flex>
    </pageContextProvider.Provider>
  </ThemeProvider>
)
